import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Trans } from '@lingui/react';
import { i18n } from 'i18n';
import TermsAndConditionsContent from './TermsAndConditionsContent';

interface TermsAndConditionsViewerDialogProps {
  open: boolean;
  onClose: () => void;
}

const TermsAndConditionsViewerDialog: React.FC<TermsAndConditionsViewerDialogProps> = ({
  open,
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    aria-labelledby="terms-and-conditions-viewer-title"
  >
    <DialogTitle id="terms-and-conditions-viewer-title">
      <Trans id="Terms and Conditions">Terms and Conditions</Trans>
    </DialogTitle>
    <DialogContent dividers>
      <Box
        tabIndex={0}
        sx={{
          maxHeight: '50vh',
          overflowY: 'auto',
          border: (t) => `1px solid ${t.palette.divider}`,
          borderRadius: 1,
          p: 2,
          backgroundColor: (t) => t.palette.background.default,
        }}
      >
        <TermsAndConditionsContent showAcceptConfirmation={false} />
      </Box>
    </DialogContent>
    <DialogActions sx={{ px: 3, py: 2 }}>
      <Button color="primary" variant="contained" onClick={onClose}>
        {i18n._('Close')}
      </Button>
    </DialogActions>
  </Dialog>
);

export default TermsAndConditionsViewerDialog;
